
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45.88 25.92h-4c-.87-1.44-3.37-5.57-3.92-6.39-.39-.59-2-2.53-6.21-2.53h-8.69a6.791 6.791 0 00-5.42 2.78c-.86 1.32-3 4.78-3.74 6.06h-3.14A2.92 2.92 0 008 28.77v8.84a1 1 0 001 1h3.61a4.62 4.62 0 004.5 3.62 4.62 4.62 0 004.51-3.62h14.17a4.62 4.62 0 004.5 3.62 4.62 4.62 0 004.5-3.62h5.28a1 1 0 001-1v-7.07c-.01-3.39-3.1-4.62-5.19-4.62zM29.69 19h2c3.29 0 4.37 1.37 4.55 1.64.42.63 2.15 3.48 3.24 5.28h-9.84l.05-6.92zm-10.38 1.87A4.72 4.72 0 0123.05 19h4.64v6.92H16.18a307.9 307.9 0 013.13-5.05zM17.1 40.23a2.62 2.62 0 010-5.24 2.62 2.62 0 010 5.24zm23.18 0a2.63 2.63 0 01-2.62-2.62 2.63 2.63 0 012.62-2.62 2.63 2.63 0 012.62 2.62 2.63 2.63 0 01-2.62 2.62zm8.78-3.62h-4.28a4.63 4.63 0 00-4.5-3.62 4.63 4.63 0 00-4.5 3.62H21.61a4.63 4.63 0 00-4.51-3.62 4.63 4.63 0 00-4.5 3.62H9.99v-7.84a1 1 0 01.76-.93h3.31a1 1 0 00.39.08h31.43s2.3 0 3 1.62h-1.69a1 1 0 000 2h1.89l-.02 5.07z"}})])
          )
        }
      }
    